import { MainLayoutQuery } from "@/lib/sanity/queries";
import { useAppSelector } from "@/lib/redux/hooks";
import { useRef } from "react";
import ClientSwitchTransition from "@/lib/components/ClientSwitchTransition";
import ClientCSSTransition from "@/lib/components/ClientCSSTransition";
import ActiveMenu from "./ActiveMenu";
import StartMenu from "./StartMenu";
import { Container } from "./styles";

type Props = {
  items: MainLayoutQuery["header"]["navigation"]["items"];
};

const Content: React.FC<Props> = (props) => {
  const { items } = props;
  const activeItem = useAppSelector((state) => state.mobileMenu.activeItem);
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <ClientSwitchTransition>
      <ClientCSSTransition
        key={activeItem ? "active" : "start"}
        nodeRef={containerRef}
        classNames="animation"
        addEndListener={(done) => {
          containerRef.current?.addEventListener("transitionend", done, false);
        }}
      >
        <Container ref={containerRef}>
          {activeItem ? (
            <ActiveMenu items={items} />
          ) : (
            <StartMenu items={items} />
          )}
        </Container>
      </ClientCSSTransition>
    </ClientSwitchTransition>
  );
};

export default Content;
